import { answerIsCorrect, answerMarkerImage } from '../../../../kinds/poll/questions/answerSchemaFields';
import { questionMultipleAppearance } from '../../../poll/questions/questionSchemaFields';
import {
  answerAwardAmount,
  answerExclusive,
  answerLogicRules,
  answerOther,
  createAnswerSchema,
} from '../answerSchemaFields';
import {
  createQuestionSchema,
  questionAutoNext,
  questionFixedRandomizeAnswers,
  questionHasAnswerCountLimit,
  questionHasAwardMultiple,
  questionHasHints,
  questionHasOthers,
  questionRandomizeAnswers,
  questionRequiresAnswer,
  questionSkipIfOnlySystemAnswers,
} from '../questionSchemaFields';
import { config } from './MultiplePoll.config';

export const schema = createQuestionSchema(
  {
    type: 'object',
    properties: {
      type: { enum: [config.name] },
      answers: {
        type: 'array',
        items: createAnswerSchema(
          answerAwardAmount,
          answerLogicRules,
          answerExclusive,
          answerOther,
          answerIsCorrect,
          answerMarkerImage,
        ),
      },
    },
    required: ['answers'],
  },
  questionAutoNext,
  questionHasAnswerCountLimit,
  questionHasAwardMultiple,
  questionHasOthers,
  questionHasHints,
  questionRandomizeAnswers,
  questionFixedRandomizeAnswers,
  questionRequiresAnswer,
  questionSkipIfOnlySystemAnswers,
  questionMultipleAppearance,
);
